/**
 * Route for `agency-dashboard`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgencyDashboardPage } from "../features/agency-dashboard/AgencyDashboardPage";

export const agencyDashboardRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agency-dashboard",
	component: AgencyDashboardPage,
});

export default agencyDashboardRoute;
